import { ILocalizedTestElement } from "@/modules/assessments/types/test.interface";

import { TestElementMode, ITestChoice } from "@/shared/components/candidate/scenes/TestElement/TestElement";

import RadioGroup from "@/ui-components/testElementComponents/RadioGroup/RadioGroup";

import styles from "./most-least-pair.module.css";

interface IMostLeastPairComponent {
  elements: [ILocalizedTestElement, ILocalizedTestElement];
  answers: (string | undefined)[];
  onChoiceSelect: (value: ITestChoice) => void;
  mode?: TestElementMode;
  disable?: boolean;
}

export default function MostLeastPairComponent({
  onChoiceSelect,
  answers,
  elements,
  mode = TestElementMode.Candidate,
  disable = false,
}: IMostLeastPairComponent) {
  const [firstEl, secondEl] = elements;
  const firstColumnLabel = firstEl.config.payload.question?.value ?? "";
  const secondColumnLabel = secondEl.config.payload.question?.value ?? "";

  const handleElementChange = (element: ILocalizedTestElement, choiceValue: any) => {
    // Find the choice key that corresponds to this choice value
    const selectedChoice = element.config.payload.choices.find((c) => c.choice === choiceValue);
    if (selectedChoice) {
      onChoiceSelect({ elementId: element.elementId, choiceKey: selectedChoice.key });
    }
  };

  const getCurrentAnswer = (element: ILocalizedTestElement, elementIndex: number) => {
    const currentAnswerKey = answers.at(elementIndex);
    return element.config.payload.choices.find((c) => c.key === currentAnswerKey)?.choice;
  };

  return (
    <div className={styles.container}>
      <fieldset className={styles.fieldset}>
        <legend className={styles.legend}>{firstColumnLabel}</legend>
        <RadioGroup
          id={firstEl.elementId}
          choices={firstEl.config.payload.choices}
          currentAnswer={getCurrentAnswer(firstEl, 0)}
          onChange={(e: any) => handleElementChange(firstEl, e.target.value)}
          mode={mode}
          disable={disable}
          isHorizontal={false}
        />
      </fieldset>
      <fieldset className={styles.fieldset}>
        <legend className={styles.legend}>{secondColumnLabel}</legend>
        <RadioGroup
          id={secondEl.elementId}
          choices={secondEl.config.payload.choices}
          currentAnswer={getCurrentAnswer(secondEl, 1)}
          onChange={(e: any) => handleElementChange(secondEl, e.target.value)}
          mode={mode}
          disable={disable}
          isHorizontal={false}
        />
      </fieldset>
    </div>
  );
}
